// ./src/utils/api/EventHighlightService.ts
//
// Event ↔ Highlight links (the `event_highlight` junction). A link either pins a
// standard catalog Highlight (highlightId) or carries a custom label/icon. The
// event details editor manages the catalog picks here — creating/removing links
// to match the chosen highlight ids — so the user never visits a separate page.
import { gql } from '@apollo/client';
import { OpResult } from '@sdflc/api-helpers';

import { ApiService } from './ApiService';

const FIELDS = `
  id
  eventId
  highlightId
  label
  icon
  orderNo
  status
`;

const LIST_QUERY = gql`
  query EventHighlightList($filter: EventHighlightFilter, $params: PaginationAndSorting) {
    eventHighlightList(filter: $filter, params: $params) {
      code
      data { ${FIELDS} }
      errors { name errors warnings }
    }
  }
`;

const CREATE_MUTATION = gql`
  mutation EventHighlightCreate($params: EventHighlightInput) {
    eventHighlightCreate(params: $params) {
      code
      data { ${FIELDS} }
      errors { name errors warnings }
    }
  }
`;

const REMOVE_MUTATION = gql`
  mutation EventHighlightRemove($where: EventHighlightWhereInput) {
    eventHighlightRemove(where: $where) {
      code
      data { id }
      errors { name errors warnings }
    }
  }
`;

export interface EventHighlight {
  id?: string;
  eventId?: string | null;
  highlightId?: string | null;
  label?: string | null;
  icon?: string | null;
  orderNo?: number | null;
  status?: number | null;
}

export interface EventHighlightInput {
  eventId?: string | null;
  highlightId?: string | null;
  label?: string | null;
  icon?: string | null;
  orderNo?: number | null;
}

export class EventHighlightService {
  static async list(eventId: string): Promise<OpResult> {
    return ApiService.executeQuery(LIST_QUERY, { filter: { eventId: [eventId] } });
  }

  static async create(params: EventHighlightInput): Promise<OpResult> {
    return ApiService.executeMutation(CREATE_MUTATION, { params });
  }

  static async remove(id: string): Promise<OpResult> {
    return ApiService.executeMutation(REMOVE_MUTATION, { where: { id } });
  }
}
